import React, { FC } from 'react';
import translate from '@translate';
import BodyTopBlock from 'src/components/BodyTopBlock';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { useNavigate } from 'react-router-dom';

type TopBlockProps = {
    reloadTableData: () => void;
};

const TopBlock: FC<TopBlockProps> = (props) => {
    const navigate = useNavigate();

    const handleChange = (newUrl: string) => {
        navigate('/orders/' + newUrl);
    };
    return (
        <BodyTopBlock
            selectTab={'expedition_packages'}
            onChangeTab={handleChange}
            actions={[
                {
                    onClick: () => props.reloadTableData(),
                    icon: <AutorenewIcon />,
                    tooltip: translate('tasks.action.synchronizeTable'),
                    variant: 'outlined',
                },
            ]}
        />
    );
};

export default TopBlock;
